const SERVICE_ID = 'system/auto-certificer';

export { SERVICE_ID };
//# sourceMappingURL=exports-browser.js.map
